import PageHero from "@/components/sections/PageHero";
import Mechanic from "@/components/sections/Mechanic";

export default function MecaniquePage() {
  return (
    <>
      <PageHero
        eyebrow="/ Petite mécanique"
        title="Atelier mobile"
        accent="à domicile"
        description="Vidange, freinage, batterie, démarreur, alternateur. Devis personnalisé selon votre véhicule, en 24h maximum."
      />
      <Mechanic hideHeader />
    </>
  );
}
